import api from "@/apis/index";
import { RES_COMMON_CODE } from "@mono/network/constant";
import {
  ROUND_TOTAL_TIME,
  LOTTERY_TIME,
  RESULT_SHOW_TIME,
  COUNT_DOWN_ITEM_INDEX,
  TURN_FRUIT_INDEXS,
  FRUITS_DETAIL,
} from "@/constants";
import _ from "lodash";
import { isLama } from "@mono/utils";

export default {
  namespaced: true,
  state: () => ({
    currRoundNum: 0, //当前轮数
    currRoundLeftTime: ROUND_TOTAL_TIME, //当前剩余时间，单位s
    fruits: [],
    betFruits: [], //下注的水果
    betFruitResult: RES_COMMON_CODE.SUCCESS, //下注结果
    showFruitMask: false, //展示水果遮罩
    selectBetCoinNum: isLama ? 10 : 100, //下注金币数
    coinBalanceNum: 0, //金币余额
    todayWinCoinNum: 0, //今天赢取金币
    lastestFruitResults: [], //最近8次开奖结果
    result: null, //游戏结果
    showResult: false, //展示结果
    turnResultFruitIndex: 0, //结果水果轮转索引
    turnFruitIndex: 0, //轮转索引的索引
  }),
  mutations: {
    init(state, payload) {
      state.resultGetTime = _.random(5, 10);
      state.currRoundNum = payload.currRoundNum;
      state.currRoundLeftTime = payload.currRoundLeftTime;
      state.fruits = _.map(payload.foodInfoList, (item) => {
        return _.assign(item, FRUITS_DETAIL[item.id - 1]);
      });
      state.fruits.splice(COUNT_DOWN_ITEM_INDEX, 0, {}); //增加倒计时占位
      state.betFruits = payload.betFoods;
      state.betFruitResult = RES_COMMON_CODE.SUCCESS;
      state.showFruitMask = false;
      state.coinBalanceNum = payload.myCoins;
      state.todayWinCoinNum = payload.todayEarnings;
      state.lastestFruitResults = _.map(payload.latestResults, (id) => {
        return FRUITS_DETAIL[id - 1];
      });
    },
    reset(state) {
      console.log("reset")
      state.resultGetTime = _.random(5, 10);
      state.currRoundNum = state.currRoundNum + 1;
      state.currRoundLeftTime = ROUND_TOTAL_TIME;
      state.betFruits = [];
      state.betFruitResult = RES_COMMON_CODE.SUCCESS;
      state.showFruitMask = false;
      state.result = null;
      state.showResult = false;
      state.turnResultFruitIndex = 0;
      state.turnFruitIndex = 0;
    },
    selectFruit(state, payload) {
      if (state.currRoundNum != payload.roundNum) {
        return;
      }

      let { coinsNum, foodId } = payload;
      let handle = false;
      state.betFruits.forEach((betFood) => {
        if (betFood.betFoodId == foodId) {
          if (coinsNum > betFood.betAmount) {
            betFood.betAmount = coinsNum;
          }
          handle = true;
        }
      });
      if (!handle) {
        state.betFruits.push({
          betAmount: coinsNum,
          betFoodId: foodId,
        });
      }
    },
    betFruitResult(state, payload) {
      state.betFruitResult = payload.code;
    },
    selectBetCoin(state, payload) {
      state.selectBetCoinNum = payload.coinNum;
    },
    updateResult(state, payload) {
      const { result } = payload;
      console.log("updateResult, ", payload)
      state.result = _.assign(result, FRUITS_DETAIL[result.drawFoodId - 1]);
    },
    timeChange(state, payload) {
      state.currRoundLeftTime = payload.currRoundLeftTime;
    },
    showResult(state) {
      console.log("showResult")
      state.showResult = true;
    },
    showFruitMask(state) {
      state.showFruitMask = true;
    },
    resultFruitTurn(state) {
      if (state.showResult && state.result) {
        const { drawFoodId } = state.result;
        if (state.turnResultFruitIndex === drawFoodId - 1) {
          return;
        }
      }

      state.turnFruitIndex = (state.turnFruitIndex + 1) % 8;
      state.turnResultFruitIndex = TURN_FRUIT_INDEXS[state.turnFruitIndex];
    },
    updateCoinBalanceNum(state, payload) {
      state.coinBalanceNum -= payload.coinNum;
    },
  },
  actions: {
    async timeChange({ dispatch, commit, state }) {
      let currRoundLeftTime = state.currRoundLeftTime - 1;
      if (currRoundLeftTime <= 0) {
        commit("reset");
        dispatch("getData");
      } else {
        if (
          !state.showFruitMask &&
          currRoundLeftTime > RESULT_SHOW_TIME &&
          currRoundLeftTime <= LOTTERY_TIME + RESULT_SHOW_TIME
        ) {
          commit("showFruitMask");
        } else if (currRoundLeftTime === RESULT_SHOW_TIME) {
          commit("showResult");
        }
        commit("timeChange", { currRoundLeftTime: currRoundLeftTime });
      }
      if (currRoundLeftTime === state.resultGetTime) {
        dispatch("getLotteryResult");
      }
    },
    async getData({ commit }) {
      const res = await api.getData();
      const { code, data } = res;
      console.log("getData, ", data)
      if (code == RES_COMMON_CODE.SUCCESS) {
        commit("init", data);
      }
    },
    async selectFruit({ commit, state }, payload) {
      const betCoinNum = state.selectBetCoinNum;
      if (betCoinNum <= 0) {
        return;
      }

      commit("betFruitResult", { code: RES_COMMON_CODE.SUCCESS });
      const res = await api.betting({
        foodId: payload.fruitId,
        coinsNum: betCoinNum,
        roundNum: state.currRoundNum,
      });
      const { code, data } = res;
      if (code === RES_COMMON_CODE.SUCCESS) {
        commit("selectFruit", data);
        commit("updateCoinBalanceNum", { coinNum: betCoinNum });
      } else {
        commit("betFruitResult", { code });
      }
    },
    async selectBetCoin({ commit }, payload) {
      commit("selectBetCoin", payload);
    },
    async getLotteryResult({ commit, state }) {
      const res = await api.getLotteryResult();
      const { code, data } = res;
      console.log("getLotteryResult, ", data)
      if (
        code == RES_COMMON_CODE.SUCCESS &&
        data.roundNum == state.currRoundNum
      ) {
        commit("updateResult", { result: data });
      }
    },
  },
};
